/** URL normalization. `normalizeUrl` IS the protocol gate: only http/https/data pass, so `javascript:` and every other scheme resolve to null (pinned by the sibling test). There is no separate sanitizer module. */

import { toSafeString } from '@federa/const/string-guards';
/** Normalize and validate a URL, encoding path segments; handles protocol-relative URLs and spaces, and returns null for anything invalid or outside http/https/data. */
export function normalizeUrl(input: string | null | undefined): string | null {
	if (!input) return null;
	let s = toSafeString(input);
	if (!s) return null;
	if (s.startsWith('//')) s = `https:${s}`;
	// Only allow absolute URLs with http, https, or data protocols
	const isAbsolute = /^(https?:|data:)/i.test(s);
	if (!isAbsolute) return null;
	try {
		const u = new URL(s);
		// Encode only the path segments to avoid spaces breaking requests
		u.pathname = u.pathname
			.split('/')
			.map((seg) => (seg ? encodeURIComponent(decodeURIComponent(seg)) : seg))
			.join('/');
		return u.toString();
	} catch {
		// Intentional: invalid URL returns null sentinel for caller to handle
		return null;
	}
}
